import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const wigle = defineConnector({
  identifier: "wigle",
  name: "WiGLE",
  tagLine: "Wireless network mapping",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.wigle\\.net/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiName,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [WiGLE](https://wigle.net/) and navigate to your account page to find your **API Name** and **API Token**.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API name",
          required: true,
          target: { kind: "configuration", field: "apiName" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.wigle.net/api/v2/stats/countries",
  },
});
